export default "__VITE_ASSET__Dl3gfAu1__"